import * as analytics from 'analytics/Analytics';
import {AA_MONOMERS_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import {ActionOrigin} from 'constants/AnalyticsConstants';

export const AaMonomerCreationMethod = {
  HELM: 'HELM',
  CSV: 'CSV',
  MANUAL: 'MANUAL',
} as const;

export type AaMonomerCreationMethod = (typeof AaMonomerCreationMethod)[keyof typeof AaMonomerCreationMethod];

export interface EditedAaMonomerFields {
  name: boolean;
  symbol: boolean;
  smiles: boolean;
  capping_groups: boolean;
  custom_molecular_weight: boolean;
}

export function trackOpenedAaMonomerLibrary(): void {
  analytics.trackEvent(AA_MONOMERS_ANALYTICS_ACTIONS.OPENED_AA_MONOMER_LIBRARY, {
    action_origin: ActionOrigin.MOLBIO_AA_MONOMER_LIBRARY_PAGE,
  });
}

export function trackCreatedAaMonomers(
  monomerIds: Array<string>,
  creationMethod: AaMonomerCreationMethod
): void {
  if (monomerIds.length === 0) {
    return;
  }
  analytics.trackEvent(AA_MONOMERS_ANALYTICS_ACTIONS.CREATED_AA_MONOMER, {
    count: monomerIds.length,
    creation_method: creationMethod,
    action_origin: ActionOrigin.MOLBIO_AA_MONOMER_LIBRARY_PAGE,
  });
}

export function trackEditedAaMonomer(monomerId: string, editedFields: EditedAaMonomerFields): void {
  if (!Object.values(editedFields).some((changed) => changed)) {
    return;
  }
  analytics.trackEvent(AA_MONOMERS_ANALYTICS_ACTIONS.EDITED_AA_MONOMER, {
    aa_monomer_id: monomerId,
    action_origin: ActionOrigin.MOLBIO_AA_MONOMER_LIBRARY_PAGE,
    edited_fields: editedFields,
  });
}

export function trackArchivedAaMonomers(monomerIds: Array<string>): void {
  if (monomerIds.length === 0) {
    return;
  }
  analytics.trackEvent(AA_MONOMERS_ANALYTICS_ACTIONS.ARCHIVED_AA_MONOMER, {
    count: monomerIds.length,
    action_origin: ActionOrigin.MOLBIO_AA_MONOMER_LIBRARY_PAGE,
  });
}

export function trackUnarchivedAaMonomers(monomerIds: Array<string>): void {
  if (monomerIds.length === 0) {
    return;
  }
  analytics.trackEvent(AA_MONOMERS_ANALYTICS_ACTIONS.UNARCHIVED_AA_MONOMER, {
    count: monomerIds.length,
    action_origin: ActionOrigin.MOLBIO_AA_MONOMER_LIBRARY_PAGE,
  });
}
